import React from 'react';
import { logoTwitter, logoInstagram, logoLinkedin, weibo } from 'ionicons/icons';
import {
    IonAnchor,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonMenuButton,
    IonNote,
    IonPage,
    IonTitle,
    IonToolbar,
} from '@ionic/react';

const ProfilePage = () => {
    const socials = [
        {
            url: 'https://twitter.com/anlex_n',
            icon: logoTwitter
        },
        {
            url: 'https://www.instagram.com/anlex_n',
            icon: logoInstagram
        },
        {
            url: 'https://www.linkedin.com/in/anlexn',
            icon: logoLinkedin
        }
    ];

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Profile</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                <IonCard>
                    <img src="wuhan.jpg" alt="wuhan" />
                    <IonCardHeader>
                        <IonCardSubtitle>full stack javascript engineer</IonCardSubtitle>
                        <IonCardTitle>anlex N</IonCardTitle>
                    </IonCardHeader>

                    <IonCardContent>
                        I love React, Express, SQlite as if i love the world,
                        javascript is wonderful that make my life happy and simple,
                        if you are so like me, please contact me.
                        <IonItem>
                            {socials.map((social) => (
                                <a target="_blank" rel="noopener noreferrer" href={social.url}>
                                    <IonIcon size="large" icon={social.icon} />
                                </a>
                            ))}
                        </IonItem>
                    </IonCardContent>
                </IonCard>

            </IonContent>
        </IonPage>
    )
};

export default ProfilePage;